import { Link, Route, Routes } from "react-router-dom";

import { RequireAuth } from "./auth";
import { Empty } from "./components/Empty";
import { Panel } from "./components/Panel";
import { Shell } from "./components/Shell";
import { TitleBand } from "./components/TitleBand";
import "./components/components.css";
import { Inventory } from "./pages/Inventory";
import { Item } from "./pages/Item";
import { Items } from "./pages/Items";
import { Login } from "./pages/Login";
import { Market } from "./pages/Market";
import { MarketOffers } from "./pages/MarketOffers";
import { MarketPackages } from "./pages/MarketPackages";
import { Offers } from "./pages/Offers";
import { Packages } from "./pages/Packages";
import { Recipe } from "./pages/Recipe";
import { Recipes } from "./pages/Recipes";
import { Scans } from "./pages/Scans";
import { Settings } from "./pages/Settings";
import { Trades } from "./pages/Trades";
import { Trader } from "./pages/Trader";
import { TraderHistory } from "./pages/TraderHistory";
import { TraderNow } from "./pages/TraderNow";
import { Watch } from "./pages/Watch";

/** The server routes every unclaimed path to this shell on purpose, which makes
 *  the SPA solely responsible for 404s. Without this a typo'd address drew the
 *  header over a permanently blank <main>. */
function NotFound() {
  return (
    <>
      <TitleBand title="Not found" />
      <Panel>
        <Empty>
          No page at this address. <Link to="/">Back to the items</Link>.
        </Empty>
      </Panel>
    </>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="*"
        element={
          <RequireAuth>
            <Shell>
              <Routes>
                {/* The bare paths mean the whole history; /scans/:uid means one
                    scan. Same distinction on all five pages. */}
                <Route path="/" element={<Market />} />
                <Route path="/scans" element={<Scans />} />
                <Route path="/trades" element={<Trades />} />
                <Route path="/watch" element={<Watch />} />
                {/* The only page about the account rather than the market, and
                    the only place a Telegram link can be made or explained. */}
                <Route path="/settings" element={<Settings />} />
                <Route path="/scans/:uid" element={<Items />} />
                <Route path="/items/:id" element={<Item />} />
                <Route path="/recipes" element={<Recipes />} />
                <Route path="/inventory" element={<Inventory />} />
                <Route path="/recipes/:id" element={<Recipe />} />
                {/* The bare path is the stall as last walked; /history is every
                    appearance and what each one changed. A sub-path and not a
                    prop, like every other pair of views on this site. */}
                <Route path="/traders/:nick" element={<Trader />}>
                  <Route index element={<TraderNow />} />
                  <Route path="history" element={<TraderHistory />} />
                </Route>
                {/* Both spellings of every mode page, and not the same component:
                    the bare path means that mode across the whole history, the
                    /scans/:uid one means that mode in one scan. */}
                <Route path="/buy" element={<MarketOffers mode="buy" />} />
                <Route path="/sell" element={<MarketOffers mode="sell" />} />
                <Route path="/craft" element={<MarketOffers mode="craft" />} />
                <Route path="/scans/:uid/buy" element={<Offers mode="buy" />} />
                <Route path="/scans/:uid/sell" element={<Offers mode="sell" />} />
                <Route path="/scans/:uid/craft" element={<Offers mode="craft" />} />
                {/* Both spellings of the packages page, and not the same
                    component either: the bare path means every lot ever
                    scanned, the /scans/:uid one means that scan's lots —
                    which is what /packages meant before the all-time pages. */}
                <Route path="/packages" element={<MarketPackages />} />
                <Route path="/scans/:uid/packages" element={<Packages />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Shell>
          </RequireAuth>
        }
      />
    </Routes>
  );
}
